module.exports = __webpack_public_path__ + "static/graph-year-4-7fa3d6620a60eac7b5e2c9543244913e.svg";